<template>
    <div>
        <SnapService v-if="isdatalistsnap" v-bind:setidoutletsetservice="setidoutlet"
                     v-on:isdetailsetservicesnap="isdetailsetservicesnap" v-on:gocreateservicesnap="showcreateservicesnap" v-on:gotoedit="showeditservicesnap" ref="listlayanansnap"/>
        <SnapCreate v-if="isdatacreatesnap" v-bind:setidoutletsetservice="setidoutlet" v-on:backtolist="showlistlayanansnapp" />
        <SnapEdit v-if="isdataeditsnap" v-bind:setidoutletsetservice="setidoutlet" v-bind:dataidlayanansnap="datalistlayanansnap" v-on:backtolist="showlistlayanansnapp" />
    </div>
</template>

<script>
    import SnapService from "../../Snap/SnapService";
    import SnapCreate from "../../Snap/SnapCreate";
    import SnapEdit from "../../Snap/SnapEdit";
    export default {
        name: "SetSnapService",
        props:['setidoutlet'],
        components:{
            SnapEdit,SnapCreate,SnapService
        },
        data(){
            return{
                isdatalistsnap:false,
                isdatacreatesnap:false,
                isdataeditsnap:false,
                idoutlet:this.setidoutlet,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                datalistlayanansnap:{
                    idsnap:'',
                }
            }
        },
        mounted() {
            this.showlistlayanansnap()

        },
        methods:{
            showlistlayanansnap(){
                this.isdatalistsnap=true;
                this.isdatacreatesnap=false;
                this.isdataeditsnap=false;
            },
            getlistlayanansnap(){
                this.$refs.listlayanansnap.listsnap()
                this.backButtonPressed(this.$refs.listlayanansnap.back)
            },
            showlistlayanansnapp(){
                this.isdatalistsnap=true;
                this.isdatacreatesnap=false;
                this.isdataeditsnap=false;
                $('#listlayanansnap').show()
                this.getlistlayanansnap()
            },
            showcreateservicesnap(){
                this.isdatalistsnap=true;
                this.isdatacreatesnap=true;
                this.isdataeditsnap=false;
                $('#listlayanansnap').hide()
            },
            showeditservicesnap(idsnap){
                this.isdatalistsnap=true;
                this.isdatacreatesnap=false;
                this.isdataeditsnap=true;
                $('#listlayanansnap').hide()
                this.datalistlayanansnap.idsnap=idsnap
            },

            isdetailsetservicesnap(){
                this.$emit('isdetail')
            },
        }
    }
</script>

<style scoped>

</style>